export default __webpack_public_path__ + "static/media/AQ360-UserGuide-20220812.76846a76.pdf";